export default __webpack_public_path__ + "assets/redis.a8a2702a.svg";